// Import Dependencies
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import isPlainObject from 'lodash/isPlainObject';

// Import Stylesheet
import styles from './suggestedCities.css';

@inject('suggestedCitiesStore', 'formsStore')
@observer
export default class SuggestedCities extends Component {
    closeSuggestedCities(e) {
        e.preventDefault();
        this.props.suggestedCitiesStore.setShowSuggestedCities(false);
    }

    selectCity(e, obj) {
        e.preventDefault();
        if (
            isPlainObject(obj) &&
            obj.ZipCode &&
            obj.City &&
            obj.StateCode &&
            obj.CountryCode
        ) {
            // set suggested city
            this.props.formsStore.setFormData('ZipCode', obj.ZipCode);
            this.props.formsStore.setFormData('City', obj.City);
            this.props.formsStore.setFormData('StateCode', obj.StateCode);
            this.props.formsStore.setFormData('CountryCode', obj.CountryCode);

            // rerun estimate
            this.props.estimatePayment();
        }
    }

    nextPage(e) {
        e.preventDefault();
        // if current page is less than total number of pages
        if (this.props.suggestedCitiesStore.suggestedCityCurrentPage < this.props.suggestedCitiesStore.suggestedCityTotalPages) {
            this.props.suggestedCitiesStore.setSuggestedCityCurrentPage(this.props.suggestedCitiesStore.suggestedCityCurrentPage + 1);
        }
    }

    previousPage(e) {
        e.preventDefault();
        // if current page isn't first page
        if (this.props.suggestedCitiesStore.suggestedCityCurrentPage > 1) {
            this.props.suggestedCitiesStore.setSuggestedCityCurrentPage(this.props.suggestedCitiesStore.suggestedCityCurrentPage - 1);
        }
    }

    render() {
        const {
            numberOfItemsPerPage,
            suggestedCities,
            showSuggestedCities,
            suggestedCityCurrentPage,
            suggestedCityTotalPages
        } = this.props.suggestedCitiesStore;
        const { wrapperClass } = this.props;

        return showSuggestedCities &&
            <div className={`${styles.suggestedCities} ${wrapperClass || ''}`} id="suggested-cites">
                <p className={styles.paragraph}>
                    We couldn't find an exact match for your city. Here's what we found for your zip code. Are any of these a good fit?
                </p>
                <ul>
                    {suggestedCities.map((city, i) => {
                        if (
                            i >= (numberOfItemsPerPage * (suggestedCityCurrentPage - 1)) &&
                            i < (numberOfItemsPerPage * suggestedCityCurrentPage)
                        ) {
                            return (
                                <li key={`suggested-city-${city.City}`}>
                                    <a href="" onClick={e => this.selectCity(e, city)}>
                                        {city.City.toLowerCase()}, {city.StateCode.toUpperCase()}
                                    </a>
                                </li>
                            );
                        }
                        return false;
                    })}
                </ul>
                {suggestedCityTotalPages > 1 &&
                    <nav>
                        <a
                            className={styles.less}
                            href=""
                            id="suggested-cities__before"
                            onClick={e => this.previousPage(e)}
                        >
                            less
                        </a>
                        <small>{suggestedCityCurrentPage} of {suggestedCityTotalPages}</small>
                        <a
                            className={styles.more}
                            href=""
                            id="suggested-cities__after"
                            onClick={e => this.nextPage(e)}
                        >
                            more
                        </a>
                    </nav>}
            </div>;
    }
}
